import {useEffect, useState} from 'react';
import * as Const from "../Const";
import axios from "axios";

function useUserSessionInfo(onError) {

    const [sessionId, setSessionId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [userName, setUserName] = useState(null);
    const [remoteAddr, setRemoteAddr] = useState(null);

    useEffect(() => {
        console.log("useUserSession start")
        let isActive = true;
        try {
            console.log("useUserSession getting session");
            axios.get(Const.API_CLOUD_USERS_AUTH_REL_USER, {withCredentials: true}).then(res => {
                if (isActive) {
                    const dataJson = res['data'];
                    console.log("useUserSession:", dataJson);
                    console.log("useUserSession user:", dataJson['user']);
                    console.log("useUserSession id:", dataJson['id']);
                    // console.log("session stringify:", JSON.stringify(dataJson));
                    // localStorage.setItem(Const.COOKIE_SESSION, JSON.stringify(dataJson));

                    setSessionId(dataJson['id']);
                    setUserId(dataJson['user_id']);
                    setUserName(dataJson['user']['username']);
                    setRemoteAddr(dataJson['remote_addr']);
                }
            }).catch(error => {
                if (isActive) {
                    console.log("useUserSession error: ", JSON.stringify(error));
                    onError();
                }
            });
        } catch (exception) {
            if (isActive) {
                console.log("useUserSession exception: ", JSON.stringify(exception));
                // navigation("/user/login");
            }
        }

        return () => {
            console.log("useUserSession stop")
            isActive = false;
        }

    }, [onError]);


    return [sessionId, userId, userName, remoteAddr];

}

export default useUserSessionInfo